import { createContext } from "react";

const FormNameContext = createContext("");

export default FormNameContext;
